define('shared/initializer/form/adapters/ForgotPasswordCardinal',[
    '$',
    '../constants',
    './Bootstrap3',
    './mixins/LabelFloatable',
    './mixins/EnterToSubmit',
    './mixins/InputValuePersistable',
    './mixins/InputValueRecoverable',
    './mixins/CardinalForgotPassword',
    './mixins/AfterSubmitActionTriggerable',
    'shared/lib/ctor'
    ],
function (
    $,
    constants,
    Bootstrap3Adapter,
    LabelFloatable,
    EnterToSubmit,
    InputValuePersistable,
    InputValueRecoverable,
    CardinalForgotPassword,
    AfterSubmitActionTriggerable,
    ctor
) {
    'use strict';

    var Ctor = ctor(function() {
        var me = this;

        me.base.apply(me, arguments);
        me.mixin(
            CardinalForgotPassword,
            LabelFloatable,
            EnterToSubmit,
            InputValuePersistable,
            AfterSubmitActionTriggerable,
            InputValueRecoverable
        );

    }).inherit(Bootstrap3Adapter);

    return Ctor;
});

